var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#2E3045",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4385_57210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6421 22.0872L47.3162 34.1477C47.4643 34.2344 47.5872 34.3584 47.6726 34.5074C47.758 34.6563 47.8029 34.825 47.8029 34.9967C47.8029 35.1683 47.758 35.337 47.6726 35.486C47.5872 35.6349 47.4643 35.7589 47.3162 35.8456L26.6421 47.9061C26.4923 47.9935 26.3221 48.0398 26.1487 48.0402C25.9753 48.0406 25.8048 47.9952 25.6546 47.9085C25.5044 47.8218 25.3798 47.697 25.2934 47.5466C25.207 47.3962 25.1619 47.2257 25.1626 47.0522V22.9371C25.1626 22.7641 25.2082 22.594 25.2949 22.4442C25.3815 22.2944 25.5062 22.1701 25.6563 22.0839C25.8064 21.9976 25.9766 21.9525 26.1497 21.9531C26.3228 21.9537 26.4926 22 26.6421 22.0872Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4385_57210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.2189,
    height: 47.2189,
    fill: "white",
    transform: "translate(11.3906 11.3906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.8b80511b60ff815d27297243a2e65ddf.svg";
export { ForwardRef as ReactComponent };